import React from 'react';
import i18n from '../i18n';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        // TODO: wire to an error-reporting service (Sentry etc.) before launch.
        console.error('[ErrorBoundary]', error, info);
    }

    render() {
        if (this.state.error) {
            const isDev = process.env.NODE_ENV !== 'production';
            const t = i18n.t.bind(i18n);
            return (
                <div style={{ padding: 24, textAlign: 'center', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                    <h3 style={{ color: '#1f2430', marginBottom: 8 }}>{t('errors.something_wrong')}</h3>
                    <p style={{ color: '#5b6472' }}>{t('errors.refresh_to_retry')}</p>
                    {isDev && (
                        <pre style={{ color: '#c0392b', whiteSpace: 'pre-wrap', fontSize: 12, textAlign: 'left', marginTop: 16 }}>
                            {this.state.error.toString()}
                        </pre>
                    )}
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
